import AWS from 'aws-sdk';
import ora from 'ora';
import Table from 'cli-table';
import Debug from '../../helpers/debug.js';
import descriptions from '../../helpers/descriptions.js';
import { pr, printJSON, themed } from '../../helpers/print.js';
import { genCredentialsOnClientApi, deleteTenantSchedules } from '../../helpers/api.js';

const debug = Debug('commands:tenants:delete');

const command = 'delete';

const desc = 'Delete tenant';

const builder = async (yargs) => {
  debug('builder', command);

  return yargs.option('tenant', descriptions.options['tenant'].config);
};

const handler = async (argv) => {
  debug('handler', command, argv);

  const { hg, json, apikey, env, tenant } = argv;
  const { clientApiBaseUri } = hg;

  let message;
  let spinner = ora();
  try {
    if (tenant === 'default') {
      throw new Error('It\'s not possible to delete "default" tenant!');
    }

    message = themed(`Deleting tenant ${tenant} schedules`);

    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));

    await deleteTenantSchedules({
      debug,
      baseUri: clientApiBaseUri,
      env,
      apikey,
      tenant,
    });

    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));

    message = themed(`Verifying user and authorizing`);

    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));

    const { accessKeyId, secretAccessKey, sessionToken } = await genCredentialsOnClientApi({
      debug,
      baseUri: clientApiBaseUri,
      task: 'tenant-delete',
      env,
      tenant,
      apikey,
    });

    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));

    // created authenticated S3 instance
    const s3 = new AWS.S3({
      accessKeyId,
      secretAccessKey,
      sessionToken,
    });

    message = themed(`Deleting tenant ${tenant} for environment ${themed(env, 'info')}`);
    !json && spinner.start(themed(`In progress: ${message}...`, 'secondary'));

    while (true) {
      // List objects, 1000 keys at a time
      const s3Objects = await s3
        .listObjectsV2({
          Bucket: env,
          Prefix: `${tenant}/`,
        })
        .promise();

      const Objects = (s3Objects.Contents || []).map(({ Key }) => ({ Key }));

      if (Objects.length === 0) {
        break;
      }

      // Purge the objects
      const response = await s3
        .deleteObjects({
          Bucket: env,
          Delete: {
            Objects,
          },
        })
        .promise();
    }

    !json && spinner.succeed(themed(`Finished: ${message}.`, 'secondary'));

    if (json) {
      printJSON({ statu: 'success', tenantDeleted: tenant });
    } else {
      // generate results table
      const table = new Table({ head: ['Tenant ID'] });
      table.push([tenant]);

      // print results
      console.log(table.toString());
    }
  } catch (err) {
    if (json) {
      printJSON({ status: 'error', error: err });
    } else {
      spinner.fail(themed(`Error: ${message}.`, 'secondary'));

      pr(themed(`Message: ${themed(err.message)}`, 'secondary'));

      debug(err);

      if (err && err.response && err.response.data) {
        debug('response', err.response.data);
      }
    }
  }
};

export { command, desc, builder, handler };
